"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const BackgroundImageContainer_1 = __importDefault(require("../BackgroundImageContainer"));
const Container_1 = __importDefault(require("../Container"));
const ConditionalWrapper_1 = __importDefault(require("../ConditionalWrapper"));
const styles = require('./Section.module.scss');
const Section = ({ backgroundColor, backgroundImageProps: { backgroundImageUrl, backgroundImageName, classes: { root: rootClassName, background: backgroundClassName } = {
    root: '',
    background: '',
}, fallbackImageName, } = {}, backgroundImageProps, children, className = '', id, slim, type = 'section', }) => {
    const SectionTag = type;
    const showBackgroundImage = (0, react_1.useMemo)(() => !!backgroundImageUrl || !!backgroundImageName || !!fallbackImageName || !!backgroundColor, [backgroundImageUrl, backgroundImageName, fallbackImageName, backgroundColor]);
    return (react_1.default.createElement(ConditionalWrapper_1.default, { condition: showBackgroundImage, wrapper: (wrapperChildren) => (react_1.default.createElement(BackgroundImageContainer_1.default, Object.assign({ classes: {
                root: (0, classnames_1.default)({
                    [styles.lightGrey]: backgroundColor === 'light-grey',
                    [styles.darkGrey]: backgroundColor === 'dark-grey',
                    [rootClassName]: !!rootClassName,
                }),
                background: (0, classnames_1.default)({ [backgroundClassName]: !!backgroundClassName }),
            } }, backgroundImageProps), wrapperChildren)) },
        react_1.default.createElement(Container_1.default, { id: id },
            react_1.default.createElement(SectionTag, { className: (0, classnames_1.default)(styles.root, {
                    [styles.slim]: !!slim,
                    [className]: !!className,
                }) }, children))));
};
exports.default = (0, react_1.memo)(Section);
//# sourceMappingURL=Section.js.map